"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagePickerType = exports.FeatureRenwalType = void 0;
var FeatureRenwalType;
(function (FeatureRenwalType) {
    FeatureRenwalType[FeatureRenwalType["ONE_TIME"] = 0] = "ONE_TIME";
    FeatureRenwalType[FeatureRenwalType["RECURRING"] = 1] = "RECURRING";
})(FeatureRenwalType = exports.FeatureRenwalType || (exports.FeatureRenwalType = {}));
var PackagePickerType;
(function (PackagePickerType) {
    PackagePickerType["Default"] = "default";
    PackagePickerType["EditorX"] = "editorx";
    PackagePickerType["Dayful"] = "dayful";
    PackagePickerType["Studio"] = "studio";
    PackagePickerType["Sunrise"] = "sunrise";
    PackagePickerType["Sandbox"] = "sandbox";
    PackagePickerType["EditorXToStudio"] = "editorx_to_studio";
})(PackagePickerType = exports.PackagePickerType || (exports.PackagePickerType = {}));
//# sourceMappingURL=types.js.map